import styled from 'styled-components';

export const Campo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-bottom: ${({ theme }) => theme.space.md};
`;

export const Etiqueta = styled.label`
  font-size: 0.85rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textMuted};
  letter-spacing: 0.03em;
`;

export const Entrada = styled.input`
  min-height: 44px;
  padding: 0.55rem 0.9rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radii.sm};
  background: ${({ theme }) => theme.colors.surface};
  color: ${({ theme }) => theme.colors.text};
  transition: border-color 200ms ease;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.sage};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.sageLight};
  }
`;

export const Selector = styled.select`
  min-height: 44px;
  padding: 0.55rem 0.9rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radii.sm};
  background: ${({ theme }) => theme.colors.surface};
  color: ${({ theme }) => theme.colors.text};
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.sage};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.sageLight};
  }
`;

export const AreaTexto = styled.textarea`
  min-height: 90px;
  padding: 0.55rem 0.9rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radii.sm};
  background: ${({ theme }) => theme.colors.surface};
  color: ${({ theme }) => theme.colors.text};
  resize: vertical;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.sage};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.sageLight};
  }
`;

export const MensajeError = styled.p`
  background: ${({ theme }) => theme.colors.dangerLight};
  color: ${({ theme }) => theme.colors.danger};
  border-radius: ${({ theme }) => theme.radii.sm};
  padding: 0.6rem 0.9rem;
  font-size: 0.9rem;
  margin-bottom: ${({ theme }) => theme.space.md};
`;

export const MensajeExito = styled.p`
  background: ${({ theme }) => theme.colors.successLight};
  color: ${({ theme }) => theme.colors.success};
  border-radius: ${({ theme }) => theme.radii.sm};
  padding: 0.6rem 0.9rem;
  font-size: 0.9rem;
  margin-bottom: ${({ theme }) => theme.space.md};
`;
